<template>
    <div
        :class="['promo-block', layout.layout ]"
        :style="{
            backgroundImage: `url(${layout.image.url})`
        }"
    >
        <img
            :src="layout.image.url"
            :alt="layout.image.alt"
            :title="layout.image.title"
            class="seo-image"
        />
        <div class="text">
            <div class="heading">
                <h2 v-html="layout.title"/>
                <p>{{ layout.description }}</p>
            </div>
            <div class="footer">
                <Cta
                    :type="currentComponent"
                    :to="$trl(currentRoute)"
                    :href="currentHref"
                    :target="target"
                    class="link"
                >
                    {{layout.cta.caption}}
                </Cta>
            </div>
        </div>
    </div>
</template>

<script>
import Cta from '@/components/Cta'
const routes = {
    project: 'Project',
    market: 'Market',
    technique: 'Technique',
    story: 'Story',
    'custom-page': 'Custom'
}
export default {
    components: {
        Cta
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    },
    computed: {
        isRouterLink() {
            return this.layout.cta.type === 'object' || this.layout.cta.type === 'link'
        },
        currentComponent() {
            return this.isRouterLink ? 'router-link' : 'a'
        },
        currentRoute() {
            if(this.layout.cta.type === 'object') {
                return {
                    name: routes[this.layout.cta.object.post_type],
                    params: {
                        slug: this.layout.cta.object.post_name,
                        locale: this.$route.params.locale
                    }
                }
            } else if(this.layout.cta.type === 'link') {
                return {
                    name: this.layout.cta.link
                }
            } else {
                return {name: ''}
            }
        },
        currentHref() {
            if(this.isRouterLink) {
                return null
            } else if(this.layout.cta.type === 'url'){
                return this.layout.cta.url
            } else if(this.layout.cta.type === 'download'){
                return this.layout.cta.file
            }
            return ''
        },
        target() {
            if(this.isRouterLink) {
                return '_self'
            } else {
                return '_blank'
            }

        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.promo-block
    height: 695px
    margin-top: 10%
    margin-bottom: 10%
    position: relative
    background-position: 50% 50%
    background-repeat: no-repeat
    background-size: cover
    overflow: hidden
    &:after
        content: ""
        display: block
        width: 100%
        height: 210px
        background-image: url('./../../assets/cross.svg')
        background-position: 50% 50%
        background-size: 45px 45px
        opacity: 0.3
        position: absolute
        left: 0
        bottom: 0
    &.slim
        height: 365px
        &:after
            height: 90px
            background-position: 50% 0%

.image-holder
    width: 528px
    height: 528px
    position: absolute
    z-index: -1
    top: 50%
    right: 45%
    margin-top: -264px
    img
        width: 100%
        height: auto
.text
    height: 100%
    display: flex
    flex-direction: column
    margin-right: 37%
    justify-content: center
    background-color: rgba(#004489, 0.95)
    padding-left: 12.5%
    padding-right: 12.5%
    .slim &
        padding-left: 5%
        padding-right: 5%
    h2
        color: #ffffff
        max-width: 10em
        .slim &
            font-size: 50px
            flex: 0.4
    p
        color: #ffffff
        .slim &
            flex: 0.6
.heading
    .slim &
        display: flex
.footer
    margin-top: 5%
    position: relative
    z-index: 1
    .slim &
        display: flex
        justify-content: flex-end
.cta
</style>
